import { Phone } from "lucide-react";
import { BRAND } from "@/lib/site";
import { Link } from "react-router-dom";

export default function CallStrip() {
  return (
    <section className="bg-slate-900 text-white" data-testid="call-strip">
      <div className="fg-container flex flex-col items-start gap-6 py-14 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-md bg-yellow-400 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-slate-900">
            24/7 Emergency
          </div>
          <h3 className="mt-4 max-w-xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
            Need a plumber now? We are a call away.
          </h3>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <a
            href={BRAND.phoneTel}
            data-testid="callstrip-phone-btn"
            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-6 py-4 font-bold text-white hover:bg-blue-700"
          >
            <Phone className="h-5 w-5" />
            Call {BRAND.phone}
          </a>
          <Link
            to="/contact#quote"
            data-testid="callstrip-quote-btn"
            className="inline-flex items-center gap-2 rounded-lg border-2 border-white/80 px-6 py-4 font-bold text-white hover:bg-white hover:text-slate-900"
          >
            Free Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
